// Module
var code = `<div class="modal-dialog">
  <div class="modal-content">
    <button type="button" class="btn p-0 btn-close" data-bs-dismiss="modal" aria-label="Close">x</button>
    <div class="modal-body d-grid" init-bind>
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-5 order-1 order-md-0 align-items-center" ng-if="\$ctrl.page.options.hsform.modal.image">
          <img ng-src="https://media.mirasee.com/{{\$ctrl.page.options.hsform.modal.image}}" alt="" class="img-fluid mx-auto" width="" height="" loading="eager" decoding="async" fetchpriority="auto">
        </div>
        <div class="col order-0 order-md-1 align-self-center" ng-switch="\$ctrl.page.id">
          <h2 class="text-white mb-3" ng-if="\$ctrl.page.options.hsform.modal.heading" ng-bind-html="\$ctrl.page.options.hsform.modal.heading"></h2>
          <h4 class="text-white mt-3" ng-if="\$ctrl.page.options.hsform.modal.subheading" ng-bind-html="\$ctrl.page.options.hsform.modal.subheading"></h4>
          <div ng-switch-when="762">
            <div ng-include="\$ctrl.modalinc"></div>
            <!-- <div id="tpl-header" ng-include src="'/pwyc.html'"></div> -->
          </div>
          <div ng-switch-when="762|836|1014|1063|1147|1381|1479" ng-switch-when-separator="|">
            <div ng-include="\$ctrl.modalinc"></div>
            <!-- <div ng-include="'modal.html'"></div> -->
          </div>
          <hsform ng-switch-default formtarget="hsform1" init-form="\$ctrl.initHSOptin()"></hsform>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;